import { useLang } from "@/context/LangContext";
import { Globe } from "lucide-react";
import { useState } from "react";

const LANGS = [
  { code: "fr", label: "FR" },
  { code: "en", label: "EN" },
  { code: "es", label: "ES" },
  { code: "it", label: "IT" },
  { code: "de", label: "DE" },
  { code: "pt", label: "PT" },
];

export default function LangSwitcher() {
  const { lang, setLang } = useLang();
  const [open, setOpen] = useState(false);
  return (
    <div className="relative" data-testid="lang-switcher">
      <button
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-1.5 rounded-full border border-wine-200/60 bg-white px-3 py-1.5 text-xs font-medium text-neutral-700 transition-all hover:bg-wine-50"
        data-testid="lang-switcher-button"
      >
        <Globe className="h-3.5 w-3.5" />
        {lang.toUpperCase()}
      </button>
      {open && (
        <div className="absolute right-0 z-50 mt-1.5 w-28 overflow-hidden rounded-xl border border-neutral-200 bg-white shadow-lg">
          {LANGS.map((l) => (
            <button
              key={l.code}
              onClick={() => { setLang(l.code); setOpen(false); }}
              className={`block w-full px-3 py-2 text-left text-xs transition-colors hover:bg-wine-50 ${
                lang === l.code ? "bg-wine-50 font-semibold text-wine-700" : "text-neutral-700"
              }`}
              data-testid={`lang-option-${l.code}`}
            >
              {l.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
